<template>
	<transition name="ui-close-hint" appear>
		<div class="ui-close-hint">
			<slot />
		</div>
	</transition>
</template>

<script>
export default {
	name: 'ui-close-hint'
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'


.ui-close-hint
	position fixed
	left 0
	right 0
	bottom 40px
	font-size 2rem
	color #fff
	opacity 0
	text-align center
	// text-shadow -1px -1px black, 1px -1px black, -1px 1px black, 1px 1px black
	opacity 0.1
	animation hint 3s linear infinite alternate
	// &.ui-close-hint-enter-active, &.ui-close-hint-leave-active
	// 	transition 0.5s easeOutQuart 0.45s
	// &.ui-close-hint-enter, &.ui-close-hint-leave-to
	// 	opacity 0


@keyframes hint
	0%
		opacity 0.1
	100%
		opacity 0.3


</style>